import { render, staticRenderFns } from "./MyPatients.html?vue&type=template&id=107216e9&external"
import script from "./MyPatients.vue?vue&type=script&lang=js"
export * from "./MyPatients.vue?vue&type=script&lang=js"
import style0 from "./MyPatients.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports